import { render, staticRenderFns } from "./DecimalElement.vue?vue&type=template&id=6fb090d6&scoped=true&"
import script from "./DecimalElement.vue?vue&type=script&lang=js&"
export * from "./DecimalElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb090d6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6fb090d6')) {
      api.createRecord('6fb090d6', component.options)
    } else {
      api.reload('6fb090d6', component.options)
    }
    module.hot.accept("./DecimalElement.vue?vue&type=template&id=6fb090d6&scoped=true&", function () {
      api.rerender('6fb090d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Papers/pages/Paper/components/Elements/DecimalElement.vue"
export default component.exports